import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-bottombar',
  templateUrl: './app.bottombar.component.html'
})
export class AppBottomBarComponent {

  constructor(public layoutService: LayoutService, private router: Router) { }
 

  goPrivacyPolicy(){
    this.router.navigate(['/privacy-policy']);
  }

  goCookiePolicy(){
    this.router.navigate(['/cookie-policy']);
  }

  goContactUs(){
    this.router.navigate(['/contact']);
  }

  goAboutUs(){
    this.router.navigate(['/aboutus']);
  }

  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
}
}
